import React from "react";
import {MonthsName} from "./Constants.mjs";
import {UncontrolledTooltip} from "reactstrap";

export const mins2hm = (t) => {
	if ( typeof t === 'string') return t;
	if ( typeof t !== 'number') return undefined;
	return String(Math.floor(t/60)).padStart(2,'0')+':'+String(t % 60).padStart(2,'0');
};

export const hm2mins = (s, step) => {
	if ( !s || typeof s !== 'string') return undefined;
	const p = s.split(":").map( x => parseInt(x));
	let x = 60 * p[0] + p[1];
	if ( step && typeof step === 'number' ) x = Math.round( x / step) * step;
	return x;
};

export const ts2hhmm = ts => ts.replace(/^.* (\d+):(\d+).*/,"$1:$2");

export const ts2hmm = ts => ts.replace(/^[^ ]+ /,'').replace(/^0?(\d+):(\d+).*/,"$1:$2");

export const ts2ddmm = ts => ts.replace(/^(\d+)-(\d+)-(\d+).*/,"$3/$2");

export const ts2yyyy = ts => ts.replace(/^(\d+)-(\d+)-(\d+).*/,"$1");

export const ts2uidate = ts => ( <>{ts2ddmm(ts)}<span className="mobile-no">/{ts2yyyy(ts)}</span></> );

export const ts2d = ts => ts.replace(/^(\d+)-0?(\d+)-0?(\d+).*/,"$3");
export const ts2dm = ts => ts.replace(/^(\d+)-0?(\d+)-0?(\d+).*/,"$3/$2");

export const ts2dmmm = ts =>  ts.replace(/^\d+-0?(\d+)-0?(\d+).*/,(ws,ms,ds)=>( ds + ' ' + MonthsName[ parseInt(ms) -1 ] ));

export const ts2dmy = ts => ts.replace(/^(\d+)-0?(\d+)-0?(\d+).*/,"$3/$2/$1");

export const ts2m = ts => parseInt(ts.replace(/^(\d+)-0?(\d+)-0?(\d+).*/,"$2"));
export const ts2y = ts => parseInt(ts.replace(/^(\d+)-0?(\d+)-0?(\d+).*/,"$1"));

export const ts2ymd = ts => ts.replace(/ .*/,"");

export const email2link = ( email = "noreplay@infocontenuti", options = {} ) => {
	options.subject ??= "";
	options.text ??= email.replace(/@.*/,'');
	options.title ??= email;
	if ( options.string || options.ui === false || options.format === "string" )
		return `<a href="mailto:${email}?subject=${encodeURIComponent(options.subject)}" title="${options.title.replace(/"/g,"&quot;")}">${options.text}</a>`;
	const ref = React.createRef();
	return (
		<>
			<a
				href={"mailto:"+email+"?subject="+encodeURIComponent(options.subject)}
				ret={ref}
			>
				{ options.text }
			</a>
			<UncontrolledTooltip
				target={ref}
				placement={"bottom"}
			>
				{ options.title.split("\n").map( (l,idx) =>{
					const out = [];
					if ( idx ) out.push(<br />);
					out.push(l);
					return out;
				})}
			</UncontrolledTooltip>
		</>
	);
};